// When an Efficiency Test can be saved, and saved and run: the same rules on the create and on the edit
// page, so the two buttons cannot disagree between them. A page using it gets `canSave`, `saveMissing`
// (what is still missing, as translated labels) and `executeSavedTest(id)`.
//
// The number of peers comes from the last coverage check, which the pages refresh whenever the coverage
// tab is opened: until that has run, nothing says whether the criteria leave any comparable.

import { safeGet } from '../utils/safeGet'
import efficiencyTestExecuteRejection from './efficiencyTestExecuteRejection'

export default {
  mixins: [efficiencyTestExecuteRejection],

  computed: {
    hasScoringProfileName() {
      return !!this.$store.getters['efficiencyTestsCommon/getScoringProfileNameValidation']
    },

    hasSelectedModel() {
      return !!this.$store.getters['efficiencyTestsDefinition/getSelectedModelId']
    },

    hasAllDriversSorted() {
      const unsorted = this.$store.getters['efficiencyTestsDefinition/getUnsortedModelDrivers']
      const sorted = this.$store.getters['efficiencyTestsDefinition/getSortedModelDrivers']
      return unsorted.length > 0 && sorted.length === unsorted.length
    },

    hasPeers() {
      const stats = this.$store.getters['efficiencyTestsCoverageDetail/getCoverageCheckStats']
      return safeGet(() => stats.comparablesUsedCount, 0) > 0
    },

    saveMissing() {
      const checks = [
        [this.hasScoringProfileName, 'name'],
        [this.hasSelectedModel, 'model'],
        [this.hasAllDriversSorted, 'drivers'],
        [this.hasPeers, 'peers'],
      ]
      return checks
        .filter(([isMet]) => !isMet)
        .map(([, key]) => this.$t(`efficiencyTestDetails.saveRequirements.${key}`))
    },

    canSave() {
      return this.saveMissing.length === 0
    },
  },

  methods: {
    // Execute errors are handled here so they never reach the save error handler: the test is
    // already saved at this point, so the user still lands on the list.
    executeSavedTest(id) {
      if (!id) {
        this.$bvModal.msgBoxOk(this.$t('common.genericError'))
        return Promise.resolve()
      }
      this.$store.dispatch('efficiencyTestsCommon/setLoading', true)
      return this.$store
        .dispatch('efficiencyTestsList/executeEfficiencyTest', id)
        .catch((err) => this.handleExecuteRejection(err))
        .finally(() => {
          this.$store.dispatch('efficiencyTestsCommon/setLoading', false)
        })
    },
  },
}
